export const SET_GRAPH_THEMATICS = 'SET_GRAPH_THEMATICS';

export const setGraphThematics = (graphThematics: any) => ({
  type: SET_GRAPH_THEMATICS,
  data: graphThematics,
});
